<template>
  <content-loader
    :height="107"
    :width="946"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >
    <rect
      x="20"
      y="20"
      rx="0"
      ry="0"
      width="65"
      height="65"
    />
    <rect
      x="110"
      y="20"
      rx="4"
      ry="4"
      width="220"
      height="15"
    />
    <rect
      x="110"
      y="50"
      rx="3"
      ry="3"
      width="160"
      height="10"
    />
    <rect
      x="440"
      y="21.55"
      rx="0"
      ry="0"
      width="90"
      height="34"
    />
    <rect
      x="550"
      y="21.55"
      rx="0"
      ry="0"
      width="90"
      height="34"
    />
    <rect
      x="830"
      y="21.55"
      rx="0"
      ry="0"
      width="80"
      height="34"
    />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    components: {
        ContentLoader,
    },
    props: [],
    methods: {
    },
}
</script>
